import React from 'react';

const Alcohol = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M11.353 7.48S13 8.864 13 10.93V21a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V10.93c0-2.066 1.647-3.45 1.647-3.45.799-.718.77-1.516.77-1.516V2h3.165v3.964s-.028.798.77 1.516ZM9.5 12.5l-4 4m10-14h.01m.49 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm3.5 4h.01m.49 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM20 2l-5 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Alcohol;
